import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthContainerComponent } from '@layout/auth-container/components/auth-container.component';
import { LargeButtonComponent } from '@kaseya-design-components';
import { ThemedImageComponent } from '@design/themed-image/components/themed-image/themed-image.component';

@Component({
  selector: 'itc-mobile-stub',
  templateUrl: 'mobile-stub.component.html',
  styleUrl: 'mobile-stub.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, AuthContainerComponent, LargeButtonComponent, ThemedImageComponent],
})
export class MobileStubComponent implements AfterViewChecked {
  private readonly router = inject(Router);
  private readonly authorizationService = inject(AuthorizationService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  readonly pointKeys = ['it-complete', 'kaseya-university', 'support-tickets', 'invoices'];

  get isAuthorized(): boolean {
    return this.authorizationService.isAuthorized();
  }

  logoutFromKaseyaOne(): void {
    this.router.navigate([ApplicationPath.Logout]);
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.markForCheck();
  }
}
